import React from "react";

export default function VideoHero() {
  return (
    // Wrap the entire content inside the return with curly braces and block comments
    <>
      {/* <section className="relative w-full h-[calc(100vh-80px)] overflow-hidden bg-black">
        The video is set to object-cover so it fills 100% of the 
        available height and width without leaving gaps.

        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source 
            src="/assets/images/veo.mp4" 
            type="video/mp4" 
          />
          Your browser does not support the video tag.
        </video>

        A simple transparent overlay. 
        Setting pointer-events-none ensures users can't accidentally 
        right-click or pause the background video. 

        <div className="absolute inset-0 bg-black/5 pointer-events-none" />
      </section> 
      */}
    </>
  );
}